function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.951 7.537L10.248.341l1.505 1.318-7.704 8.804L.293 6.707l1.414-1.414 2.244 2.244z",
  fill: "#4038FF"
});

var SvgOptioncheck = function SvgOptioncheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMiAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjk1MTQgNy41MzcwOEwxMC4yNDc1IDAuMzQxNDk1TDExLjc1MjcgMS42NTg1TDQuMDQ4ODIgMTAuNDYyOUwwLjI5MzAwMiA2LjcwNzExTDEuNzA3MjIgNS4yOTI4OUwzLjk1MTQgNy41MzcwOFoiIGZpbGw9IiM0MDM4RkYiLz4KPC9zdmc+Cg==";
export { SvgOptioncheck as ReactComponent };